import { Injectable } from '@angular/core';

@Injectable()
export class ExternalUrlsHelper {
  public static careersSiteUrl(
    companyId: number,
    authUrl: string,
    withEditorOpen: boolean = false,
  ): string {
    const careersUrl = `${authUrl}c/${companyId}/careers`;
    return withEditorOpen ? `${careersUrl}?redirect=#editor` : careersUrl;
  }

  public static referralsSiteUrl(
    referralsSubdomain: string,
    authUrl: string,
    recruiteeDomain: string,
  ): string {
    return `${authUrl}?redirect=${referralsSubdomain}${recruiteeDomain}`;
  }

  public static apiIntegrationUrl(
    authUrl: string,
    companyId: number,
    integration: string,
    returnTo?: string,
  ): string {
    const base = `${authUrl}c/${companyId}/integrations?integration=${integration}`;
    return returnTo ? `${base}&returnTo=${returnTo}` : base;
  }
}
